<div class="card" [ngClass]="theme">
    <div class="card-header w-full">
        <ng-content select="[card-header]">

        </ng-content>
    </div>
    <div class="card-body">
        <ng-content select="[card-body]">

        </ng-content>
    </div>
  </div>
